import { Component } from '@angular/core';
import { ModalWinNewLeadService } from './win.service';

@Component({
    selector: 'modal-win-new-lead',
    templateUrl: 'win.html',
    styleUrls: ['win.css']
})
export class ModalWinNewLeadComponent {
    public service: ModalWinNewLeadService;

    private _shown = false;

    private _setInnerStateFun: any;

    private _innerState: any;

    constructor() {
        this.service = ModalWinNewLeadService.getInstance();
        this.service.setComponent(this);

        this._setInnerStateFun = (state) => {
            this._innerState = state;
            if (state == 'ok') {
                setTimeout(() => { this.show(false); }, 10);
            }
        }
    }

    show(v: boolean) {
        if (! v && this._innerState == 'loading') return;
        this._shown = v;
    }

    hide() {
        this._shown = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/modal-win-new-lead/win.component.ts